export const PROJECTION_OBSERVER_POLICY = Object.freeze({
  maxPending: 10, deadlineMs: 5000, transportTimeoutMs: 2000,
  maxInFlight: 2, maxStageRetries: 2, retryMs: 500, maxRequestsPerSecond: 6, heartbeatMs: 5000,
  longTaskCapacity: 128, longTaskMinMs: 50, longTaskMaxMs: 60000,
});
